// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment';
// @end

// @import components
import {ActivityCalendarModuleLayout} from 'app_components/modules/campus/academic/activityCalendar'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
// @end

// @import services
import storeService from 'app_services/storeService'
import CourseActivityService from 'app_services/campus/academic/courseActivityService'
// @end

// @import types
import {IMyCourse} from 'app_types/campus/academic/myCoursesTypes'
import {IActivityCalendarEvent} from 'app_types/campus/academic/activityCalendarTypes'
import { moodleAuthFormRequest } from 'app_events/auth/actions';
import LoginMoodle from 'app_components/modules/LoginMoodle/LoginMoodle';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { external_api } from 'app_config/globals';
// @end

// @ADD Component types
interface IActivityCalendarModuleProps {}
interface IActivityCalendarModuleState {
  events: Array<IActivityCalendarEvent>
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ActivityCalendarModule extends Component<IActivityCalendarModuleProps, IActivityCalendarModuleState> {

  private courseActivityService: CourseActivityService
  private screenNotifications: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IActivityCalendarModuleProps) {
    super(props)
    this.state = {
      events: []
    }

    this.courseActivityService = new CourseActivityService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected',this.fetchActivityCalendar)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected',this.fetchActivityCalendar)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  joinMeetingButton = (url: string | null, isActive?: boolean) => {
    if (!url) return;
    return (
      <LoginMoodle redirectTo={url} targetBlank>
        <ButtonComponent
          disabled={!isActive}
          variant="secondary"
          width="100%"
          textTransform='capitalize'
          borderRadius="20px"
          padding="2px 10px"
          type="button"
        >
          Webex
        </ButtonComponent>
      </LoginMoodle>
    )
  }

  extractUrlFromTag (tag: string) {
    const regex = new RegExp(/href="(.*?)"/, 'g')
    if (!regex) return null;
    const regexExec = regex.exec(tag)
    if (!regexExec || !regexExec[1]) return null;
    return regexExec[1]
  }

  // @Add custom methods

  fetchActivityCalendar = async (data: IMyCourse | null) => {
    this.setState({events: []})

    const tags: any = this.courseActivityService.getActivityTags().reduce((accum, element) => ({ ...accum, [element.key.toString()]: element }), {})

    if (data?._id) {
      const isOnline = data?.schedulingMode?.name === 'En linea'
      const startOfMonth = `${moment().startOf('month').format('YYYY-MM-DD')}T00:00:00Z`;
      const endOfMonth   = `${moment().endOf('month').format('YYYY-MM-DD')}T23:59:59Z`;

      const dataResponse = await this.courseActivityService.fetchActivityCalendar({
        courseID: data?._id,
        courseSchedulingId: data?.courseScheduling,
        timeStart: startOfMonth,
        timeEnd: endOfMonth,
        events: ["assign", "attendance", "quiz", "forum", "session"]
      })

      if (dataResponse && dataResponse.events) {
        const events = dataResponse.events.reduce((accum: Array<any>, element) => {
          if (element.timestart) {

            let startDate = (element.timestart != null) ? moment(element.timestart).format('DD/MM/YYYY') : null;
            let endDate = (element.timefinish != null) ? moment(element.timefinish).format('DD/MM/YYYY') : null;
            let component = undefined;

            if (element?.eventtype === 'webex') {
              startDate = (element.timestart != null) ? moment(element.timestart).format('DD/MM/YYYY HH:mm') : null;
              endDate = (element.timefinish != null) ? moment(element.timefinish).format('DD/MM/YYYY HH:mm') : null;
              if (endDate) {
                const today = moment()
                const isActive = moment(element.timefinish).isSameOrAfter(today)
                if (isActive) {
                  if (element?.url) {
                    component = this.joinMeetingButton(
                      element.url,
                      isActive
                    )
                  } else if (element?.description) {
                    component = this.joinMeetingButton(
                      this.extractUrlFromTag(element?.description),
                      isActive
                    )
                  }
                }
              }
            }

            if (!isOnline && element?.activityType === 'session') {
              component = (
                <LoginMoodle targetBlank redirectTo={`${external_api?.moodle?.url}/course/view.php?id=${data?._id}`}>
                  <ButtonComponent
                    variant="secondary"
                    width="100%"
                    textTransform='initial'
                    borderRadius="20px"
                    padding="2px 10px"
                    type="button"
                  >
                    Ir a cursos
                  </ButtonComponent>
                </LoginMoodle>
              )
            }

            if (element?.activityType === 'quiz') {
              component = (
                <LoginMoodle redirectTo={`${external_api?.moodle?.url}/mod/quiz/view.php?id=${String(element.id)}`} targetBlank>
                  <ButtonComponent
                    variant="secondary"
                    width="100%"
                    textTransform='initial'
                    borderRadius="20px"
                    padding="2px 10px"
                    type="button"
                  >
                    Ir al examen
                  </ButtonComponent>
                </LoginMoodle>
              )
            }

            const index = accum.findIndex((_el) => _el.date === moment(element.timestart).format('YYYY-MM-DD'))
            let eventItem = {
              _id: element.id,
              // position: `${(count) + 1}`,
              activity: element.name,
              module: element.modulename,
              start_date: startDate,
              limit_date: endDate,
              delivery_date: (element.timecompleted != null) ? moment(element.timecompleted).format('DD/MM/YYYY') : null,
              circle_component: (tags && tags[element.status]) ? tags[element.status].color : null,
              component_render_actions: component
            }
            if (index !== -1) {
              accum[index].extendedProps.items.push({...eventItem})
            } else {
              accum.push({
                date: moment(element.timestart).add(1, 'day').format('YYYY-MM-DD'),
                color: '#8DC8E8',
                extendedProps: {
                  items: [{
                    ...eventItem
                  }]
                }
              })
            }
          }
          return accum
        }, [])
        this.setState({events})
      }
    }
  }

  render() {
    return(
      <ActivityCalendarModuleLayout
        events={this.state.events}
      />
    )
  }
}

export default connect(mapStatesToProps)(ActivityCalendarModule)
